@if (!dialogGetAsset) {
  <mat-card appearance="outlined">
    <a style="position: relative; height: 36px;" color="warn" (click)="redirectTo('/resources/list')">
      <mat-icon style="position: relative; top: 6px">chevron_left</mat-icon>
      {{ 'general.back' | transloco }}
    </a>
    <button mat-button class="icon-button" style="position: absolute; top: 0; right: 0;" (click)="sidenav.toggle();">
      <mat-icon>playlist_add_check</mat-icon>
    </button>
    <div fxFill>
      <mat-drawer-container>
        <mat-drawer opened [mode]="sidenavMode" #sidenav [disableClose]="sidenavMode === 'side'">
          <div class="list-container main-container" style="width: 285px;">
            <ng-template [ngTemplateOutlet]="resourceCategory">
            </ng-template>
          </div>
        </mat-drawer>
        <mat-drawer-content>
          <div class="list-container">
            @if (importType === 'shared') {
              @if (resourceDataEnterprise && resourceDataEnterprise.length > 0) {
                <app-resources-importer [sharedResources]="resourceDataEnterprise"></app-resources-importer>
              } @else {
                <div class="imageWrap" style="width: 100%; height: 100%" fxLayout="row" fxLayoutAlign="center center">
                  <h1>{{ 'general.resourcesCollection' | transloco }}</h1>
                </div>
              }
            } @else {
              @if (resourceData && resourceData.length > 0) {
                <app-resources-importer [sharedResources]="resourceData"></app-resources-importer>
              } @else {
                <div class="imageWrap" style="width: 100%; height: 100%" fxLayout="row" fxLayoutAlign="center center">
                  <h1>{{ 'general.resourcesCollection' | transloco }}</h1>
                </div>
              }
            }
          </div>
        </mat-drawer-content>
      </mat-drawer-container>
    </div>
  </mat-card>
} @else {
  <div fxFill fxLayout="row" class="library-dialog-view flex-lt-md-col">
    <div class="list-container main-container flex-lt-md-100" fxFlex="285px">
      <ng-template [ngTemplateOutlet]="resourceCategory">
      </ng-template>
    </div>
    <div class="list-container" fxFlex="100%">
      @if (importType === 'shared') {
        @if (resourceDataEnterprise && resourceDataEnterprise.length > 0) {
          <app-resources-importer [sharedResources]="resourceDataEnterprise" [dialogGetAsset]="dialogGetAsset" (itemSelected)="onItemSelected($event)"></app-resources-importer>
        } @else {
          <div class="imageWrap" style="width: 100%; height: 100%" fxLayout="row" fxLayoutAlign="center center">
            <h1>{{ 'general.resourcesCollection' | transloco }}</h1>
          </div>
        }
      } @else {
        @if (resourceData && resourceData.length > 0) {
          <app-resources-importer [sharedResources]="resourceData" [dialogGetAsset]="dialogGetAsset" (itemSelected)="onItemSelected($event)"></app-resources-importer>
        } @else {
          <div class="imageWrap" style="width: 100%; height: 100%" fxLayout="row" fxLayoutAlign="center center">
            <h1>{{ 'general.resourcesCollection' | transloco }}</h1>
          </div>
        }
      }
    </div>
  </div>
}



<ng-template #resourceCategory>
  <mat-accordion class="w-100">
    <mat-expansion-panel [expanded]="true" (opened)="openGroup('categories')">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>account_tree</mat-icon>
          <span class="accordionIcons">{{'general.categorizedResources' | transloco}}</span>
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      @if (categoryTreeItems.length > 0) {
        <app-category-tree #treeCategory style="width: 100%; height: 100%" [createMode]="false" [filterMode]="true" [expandAll]="false" [setCategoryValues]="categoryTreeItems" (updateTreeSelection)="onUpdateTree($event)"></app-category-tree>
      } @else {
        <div style="margin-bottom: 50px;">
          <app-loading [size]="'50px'" [style]="{ 'margin-top': '50px' }"></app-loading>
        </div>
      }
    </mat-expansion-panel>
    @if (enterprise) {
      <mat-expansion-panel (opened)="openGroup('shared')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>share</mat-icon>
            <span class="accordionIcons">{{'general.sharedResources' | transloco}}</span>
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <button style="width: 100%" (click)="getEnterpriseSharedContent()" mat-stroked-button color="warn">
          <mat-icon>cached</mat-icon>
          {{'general.syncContent' | transloco}}
        </button>
        @if (!sharedContentTreeItems || isUpdatingEnterprise) {
          <div style="margin-bottom: 30px;">
            <app-loading [size]="'50px'" [style]="{ 'margin-top': '30px' }"></app-loading>
          </div>
        } @else {
          <app-category-tree #treeCategory style="width: 100%; height: 100%" [createMode]="false" [filterMode]="false" [expandAll]="false" [setCategoryValues]="sharedContentTreeItems" (updateTreeSelection)="onUpdateShareContentTree($event)"></app-category-tree>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</ng-template>
